var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('webhooks-header')],1),_c('div',{},[_c('iframe',{attrs:{"id":"myFrame","src":this.webhookUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }